<div #findStaffWrapper class="find-staff-modal">
  @if (
    {
      isFetchedShiftAssignmentSuccessful:
        isFetchedShiftAssignmentSuccessful$ | async,
    };
    as data
  ) {
    @if (data.isFetchedShiftAssignmentSuccessful) {
      <wilson-find-staff-popup-filters>
        <wilson-grouped-shift-staff-status-filter></wilson-grouped-shift-staff-status-filter>
      </wilson-find-staff-popup-filters>
    }
    <wilson-modal-timeline [userTimelinesInfo]="userTimelinesInfo$ | async">
      <wilson-find-shift-staff-quick-filter></wilson-find-shift-staff-quick-filter>
    </wilson-modal-timeline>
    @defer (on idle) {
      <wilson-deferred-absence-timeline-view-card></wilson-deferred-absence-timeline-view-card>
      <wilson-deferred-shift-icons></wilson-deferred-shift-icons>
    }
    <wilson-timeline-modal-legend></wilson-timeline-modal-legend>
  }
</div>
